import { render, staticRenderFns } from "./SetGoals.vue?vue&type=template&id=798ba1a8"
import script from "./SetGoals.vue?vue&type=script&lang=js"
export * from "./SetGoals.vue?vue&type=script&lang=js"
import style0 from "./HuddleComponentsModern.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports